import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Switch } from "V2.0/common/switch";
import { Input } from "V2.0/common/input";

export default WebhookForm;

function WebhookForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.webhookName}
          onChange={(e) => updateFormState("webhookName", e.target.value)}
          invalid={!!errors?.webhookName}
        />
        {errors?.webhookName && (
          <ErrorMessage>{errors.webhookName}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>Webhook URL *</Label>
        <Input
          type="text"
          value={formState.endpointUrl}
          onChange={(e) => updateFormState("endpointUrl", e.target.value)}
          invalid={!!errors?.endpointUrl}
        />
        {errors?.endpointUrl && (
          <ErrorMessage>{errors.endpointUrl}</ErrorMessage>
        )}
      </Field>

      <Field className="flex items-end gap-x-2">
        <Label>Authorization</Label>
        <Switch
          color="emerald"
          checked={formState.authRequired}
          onChange={() =>
            updateFormState("authRequired", !formState.authRequired)
          }
        />
      </Field>

      {formState.authRequired && (
        <div className="flex flex-col gap-y-4 px-2">
          <Field>
            <Label>Header</Label>
            <Input
              type="text"
              value={formState.authHeader}
              onChange={(e) => updateFormState("authHeader", e.target.value)}
              invalid={!!errors?.authHeader}
            />
            {errors?.authHeader && (
              <ErrorMessage>{errors.authHeader}</ErrorMessage>
            )}
          </Field>
          <Field>
            <Label>Key *</Label>
            <Input
              type="text"
              value={formState.authKey}
              onChange={(e) => updateFormState("authKey", e.target.value)}
              invalid={!!errors?.authKey}
            />
            {errors?.authKey && <ErrorMessage>{errors.authKey}</ErrorMessage>}
          </Field>
        </div>
      )}
    </div>
  );
}
